import { Controller } from '@hotwired/stimulus'

export default (class extends Controller {
  static targets = ['mobileMenu', 'toggle']
  static values = { mobileMenuActive: Boolean, scrolled: Boolean }

  connect() {
    this.toggleScrolled()
  }

  close(event) {
    if (this.element.contains(event.target)) return

    this.mobileMenuActiveValue = false
  }

  toggleMobileMenu() {
    this.mobileMenuActiveValue = !this.mobileMenuActiveValue
  }

  mobileMenuActiveValueChanged(active) {
    this.mobileMenuTarget.hidden = !active
    this.toggleTarget.setAttribute('aria-expanded', String(active))
  }

  dismiss() {
    if (!this.mobileMenuActiveValue) return
    this.mobileMenuActiveValue = false
    this.toggleTarget.focus()
  }

  toggleScrolled() {
    this.scrolledValue = this.element.getBoundingClientRect().top <= 0
  }
})
